import { useCinematicsStore } from '@/cinematics/stores/CinematicsStore'
import { useUser } from './useUser'

export interface UseProfileCompletenessResult {
  /**
   * The server says to ask now. It already applied the per-brand "once a week,
   * max three times" rule (PRO-896), so nothing here recomputes it.
   */
  shouldPromptPhone: boolean
  suggestedCountry?: string
  /** Scopes the session ledgers so a second account on a shared device is its own. */
  profileId: string
  /** The avatar indicator and its menu entry both read this, and nothing else. */
  shouldShowIndicator: boolean
  /** Raw server state, ungated by config — the prompt's own condition reads this. */
  isPhoneMissing: boolean
}

export const useProfileCompleteness = (): UseProfileCompletenessResult => {
  const { profile, isLoggedIn } = useUser()
  // Selector, not the whole store: six components call this hook, and
  // subscribing them all to every branding merge and route change re-rendered
  // the navbar and the profile form for writes they do not read.
  const hasIndicator = useCinematicsStore(state => !!state.props?.profileCompleteness?.hasIndicator)
  const completeness = profile?.completeness
  const isPhoneMissing = isLoggedIn && !!completeness?.phoneMissing

  return {
    shouldShowIndicator: isPhoneMissing && hasIndicator,
    isPhoneMissing,
    shouldPromptPhone: isLoggedIn && !!completeness?.promptPhone,
    suggestedCountry: completeness?.suggestedCountry ?? undefined,
    profileId: profile?._id ?? '',
  }
}
